module.exports = __webpack_public_path__ + "img/footer-thumbnail-ceflore.0944edc3.webp";